import React from 'react';
import { useSelector } from 'react-redux';

import { CoreLink, DynamicMediaItem } from '@uncinc/react-drupal-core';
import type { ImmutableEntity, Langcodes } from '@uncinc/react-drupal-core/types';
import { Icon } from '@uncinc/uncinc-react-kitchen-sink';

import { useTranslation } from 'react-i18next';
import {
  WysiwygField,
} from '../../../../components';
import { TaxonomyGeneric } from '../../../../types/uncinc_profile/taxonomy';

import './style.scss';

interface TaxonomyGenericTeaserProps {
  entity: ImmutableEntity<TaxonomyGeneric>;
}

const TaxonomyGenericTeaser: React.FC<TaxonomyGenericTeaserProps> = ({ entity }) => {
  const { t } = useTranslation();
  const genericTaxonomy = entity.toJS();
  const title = genericTaxonomy.name[0].value;
  const body = genericTaxonomy.description[0].value;
  const svg = genericTaxonomy.field_svg?.[0];
  const mediaImg = genericTaxonomy.field_media_item[0];

  const language = useSelector<Immutable.Map<any, any>>((state) => state.getIn(['ui', 'language']));
  const path = genericTaxonomy.paths[language as Langcodes];

  return (
    <div className="TaxonomyGenericTeaser col-12">
      <CoreLink
        href={path}
        className="TaxonomyGenericTeaser__link"
        aria-label={title}
      >
        <div className="row">
          <div className="col-12 col-sm-4">
            <div className="TaxonomyGenericTeaser__image">
              <DynamicMediaItem
                media={mediaImg}
                imageAspectRatio="4_3"
              />
            </div>
          </div>
          <div className="col-12 col-sm-8">
            <div className="TaxonomyGenericTeaser__content">
              <h2 className="TaxonomyGenericTeaser__title">{title}</h2>
              <div className="TaxonomyGenericTeaser__body">
                <WysiwygField
                  html={body}
                />
              </div>
              <CoreLink
                href={path}
                className="TaxonomyGenericTeaser__moreinfo link--text"
              >
                {t('taxonomies.teaser.more_info')}
                <Icon name="arrow_forward" />
              </CoreLink>
            </div>
          </div>
        </div>
      </CoreLink>
    </div>
  );
};

export default TaxonomyGenericTeaser;
